import axios from 'axios';
import { ApiError } from './error';
//Specifically designed to set form errors and manage UI feedback.
//Forms

interface FormErrors {
  [key: string]: string[];
}

interface ApiErrorResponse {
  error?: string;
  message?: string;
  errors?: FormErrors;
}

export const processError = (
  error: unknown,
  setErrors: (errors: FormErrors) => void,
  setErrorMessage: (message: string | null) => void,
  setSuccessMessage: (message: string | null) => void
) => {
  // Clear success message on error
  setSuccessMessage(null);

  if (axios.isAxiosError(error)) {
    const statusCode = error.response?.status;
    const responseData = error.response?.data as ApiErrorResponse;
   
    if (responseData) {
      // Set form field-specific errors if provided
      setErrors(responseData.errors || {});

      // Prioritize `error` or `message` for generic error message
      const message = responseData.error || responseData.message || 'An error occurred.';
      setErrorMessage(`${message} (Status: ${statusCode || 'unknown'})`);
    } else {
      // Generic fallback for Axios errors without specific response data
      setErrorMessage(`Network error: ${error.message} (Status: ${statusCode || 'unknown'})`);
    }
  } else if (error instanceof ApiError) {
    // Handle custom API errors
    setErrors({});
    setErrorMessage(error.message);
  } else {
    // Handle unexpected errors
    setErrors({});
    setErrorMessage('An unexpected error occurred. Please try again.');
  }

  // Debugging log (optional, disable in production)
  if (process.env.NODE_ENV === 'development') {
    console.error('Error processed:', error);
    
  }
};

